(() => {
  if (document.documentElement.dataset.pupmdScrollV2) return;
  document.documentElement.setAttribute('data-pupmd-scroll-v2', '');

  const stickyHeaderHeight = () => {
    const headerElement = document.querySelector('.pmd-header, header-component');
    if (!(headerElement instanceof HTMLElement)) return 0;
    const position = getComputedStyle(headerElement).position;
    if (position !== 'fixed' && position !== 'sticky') return 0;
    return Math.max(0, headerElement.getBoundingClientRect().bottom);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const scrollTrigger = event.target.closest('[data-scroll-target]');
    if (!(scrollTrigger instanceof HTMLElement)) return;

    const selector = scrollTrigger.getAttribute('data-scroll-target');
    if (!selector) return;

    event.preventDefault();

    const scrollTarget = document.querySelector(selector);
    if (!(scrollTarget instanceof HTMLElement)) return;

    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const offsetSetting =
      Number.parseInt(getComputedStyle(document.documentElement).getPropertyValue('--pupmd-v2-scroll-offset'), 10) || 0;
    const offset = offsetSetting > 0 ? offsetSetting : stickyHeaderHeight() + 16;

    window.scrollTo({
      top: scrollTarget.getBoundingClientRect().top + window.scrollY - offset,
      behavior,
    });
  });
})();
